import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { AdDirective } from './shared/directives/ad.directive';
import { AdComponent } from './shared/directives/ad.component';
import * as _ from 'lodash';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { StoreComponent } from './store/store.component';
import { ShelfComponent } from './shelf/shelf.component';
import { EBEComponent } from './EBE/EBE.component';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { AlbumComponent } from './album/album.component';
import { ELEComponent } from './ELE/ELE.component';
import { MatSnackBar } from '@angular/material';

import { TranslateService } from '@ngx-translate/core';
import { LanguageTranslateObservableService } from "./shared/languageTranslateObservable.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  subscription;
  @ViewChild(AdDirective) adHost: AdDirective;

  constructor(private viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, public snackBar: MatSnackBar, private translate: TranslateService, private languageService: LanguageTranslateObservableService) {
    this.subscription = this.languageService.cast.subscribe(LanguageSelected => this.translate.use(LanguageSelected))
  }

  public appendComponent;
  public bookData;
  myContentElements;
  ngOnInit() {
    localStorage.userLogginedAt = 'first time login'
    this.appendComponentsToApp('shelf');
    //  localStorage.userData = undefined;
    localStorage.isCheckedRecents = false;
    localStorage.allGridview = undefined;
    localStorage.appServer = 'Dev';
    localStorage.selectedLanguageInd = 0;
    // localStorage.allDocsReplicated = undefined;
    document.getElementsByClassName('appMainLoader')[0]['style'].display = 'none'
  }
  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  appendComponentsToApp(appendComp) {

    // if((appendComp != 'shelf' && (localStorage.userData == 'undefined' || localStorage.userData == undefined)) && appendComp != 'store'){
    //   this.snackBar.open('Please Login', '', {
    //     duration: 2000,
    //   });
    //   return;
    // }

    switch (appendComp) {
      case 'shelf':
        this.appendComponent = ShelfComponent;
        break;
      case 'store':
        this.appendComponent = StoreComponent;
        break;
      case 'EBE':
        this.appendComponent = EBEComponent;
        break;
      case 'ALB':
        this.appendComponent = AlbumComponent;
        break;
      case 'ELE':
        this.appendComponent = ELEComponent;
        break;
    }

    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.appendComponent);
    let viewContainerRef = this.adHost.viewContainerRef;
    viewContainerRef.clear();

    let componentRef = viewContainerRef.createComponent(componentFactory);
    (<AdComponent>componentRef.instance).data = this;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts